import { Trash2, Search } from "lucide-react";
import libFloat from "../../../../util/libFloat";
import LibDateTime from "../../../../util/libDateTime";

export default function TabelaSelecionadas({ parcelas, totalValor, onRemover, onLimpar, onIrParaBusca }) {
	if (parcelas.length === 0) {
		return (
			<div className="flex-1 flex flex-col items-center justify-center gap-3 border rounded-md bg-white border-gray-300">
				<p className="text-gray-400 text-sm mb-0">Nenhuma parcela na remessa.</p>
				<button
					className="btn btn-sm btn-outline-primary inline-flex items-center gap-2"
					onClick={onIrParaBusca}
				>
					<Search size={16} /> Buscar parcelas
				</button>
			</div>
		);
	}

	return (
		<div className="flex-1 flex flex-col min-h-0 border rounded-md bg-white border-gray-300 overflow-hidden">
			<div className="shrink-0 flex items-center justify-between border-b bg-gray-50 px-4 py-2">
				<span className="text-sm text-gray-600">
					<strong className="text-gray-800">{parcelas.length}</strong>{" "}
					{parcelas.length === 1 ? "parcela" : "parcelas"}
					<span className="mx-2 text-gray-300">|</span>
					<strong className="text-emerald-600">{libFloat.strToCurrency(totalValor)}</strong>
				</span>

				<button className="btn btn-sm btn-outline-danger" onClick={onLimpar}>
					Limpar tudo
				</button>
			</div>

			<div className="flex-1 overflow-y-auto">
				<table className="table table-portal mb-0 w-full border-b">
					<thead className="color-table sticky top-0 z-10 shadow-sm">
						<tr>
							<th className="text-left font-semibold py-2 border-b">
								<span className="text-color-table">Cliente</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-24">
								<span className="text-color-table">Venda</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-24">
								<span className="text-color-table">Parcela</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-32">
								<span className="text-color-table">Vencimento</span>
							</th>
							<th className="text-right font-semibold py-2 border-b w-32">
								<span className="text-color-table">Valor</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-24">
								<span className="text-color-table">Ação</span>
							</th>
						</tr>
					</thead>

					<tbody>
						{parcelas.map((item) => (
							<tr key={item.id_conta_entrada} className="hover:bg-red-50 group">
								<td className="text-left align-middle font-medium py-2">{item.nome}</td>
								<td className="text-center align-middle text-gray-500 text-sm">
									{item.id_venda}
								</td>
								<td className="text-center align-middle text-gray-500 text-sm">
									{item.parcela}/{item.parcela_total}
								</td>
								<td className="text-center align-middle">
									{LibDateTime.parseDelphiLocal(item.data, "dd/MM/yyyy")}
								</td>
								<td className="text-right align-middle text-emerald-600 font-semibold">
									{libFloat.strToCurrency(item.valor)}
								</td>
								<td className="text-center align-middle">
									<button
										type="button"
										title="Remover da remessa"
										className="btn btn-sm btn-outline-danger p-1 rounded opacity-70 group-hover:opacity-100 transition-opacity"
										onClick={() => onRemover(item.id_conta_entrada)}
									>
										<Trash2 size={16} />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
